export default function validate(values) {
  let errors = {};
  if (!values.finance_type) {
    errors.finance_type = 'Field is Missing';
  }
  console.log("error==>", errors)
  return errors;
}